export default __webpack_public_path__ + "static/media/active-blood-pressure.01f1410f.svg";